import { connect } from "react-redux";

import HeaderFilter from "../components/Table.Header.Filters.Component";

import * as tableActions from "../commands/table.actions";

function mapStateToProps(state) {
  return {
    tables: state.tables,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    selectAll: (selections, tableKey) => {
      dispatch(tableActions.change_selections(selections, tableKey));
    },
    changeFilterType: (key, filterType, tableKey) => {
      dispatch(tableActions.change_filter_type(key, filterType, tableKey));
    },
    changeFilterValue: (key, filterOption, tableKey, value) => {
      dispatch(
        tableActions.change_filter_value(key, filterOption, tableKey, value),
      );
    },
  };
}

export const filterTableService = connect(mapStateToProps, mapDispatchToProps);
export default filterTableService(HeaderFilter);
